// import Vue from 'vue';
// import store from '../store/store';
// import { toCamelCase } from '../common/utils/strings';

// export default Vue.directive('sortBy', {
//     bind(el, binding) {
//         el.classList.add('sorted-th');
//         el.dataset.sortOrder = 'asc'; // Default sort order

//         el.addEventListener('click', () => {
//             

//             // Reset previous column sorting if clicking a different column
//             if (window.lastSortedColumn && window.lastSortedColumn !== el) {
//                 window.lastSortedColumn.classList.remove('asc', 'desc');
//                 window.lastSortedColumn.dataset.sortOrder = 'asc'; // Reset to default
//             }

//             // Toggle sort order for current column
//             el.dataset.sortOrder = el.dataset.sortOrder === 'asc' ? 'desc' : 'asc';

//             // Remove old sorting classes and apply new one
//             el.classList.remove('asc', 'desc');
//             el.classList.add(el.dataset.sortOrder);

//             // Update last sorted column reference
//             window.lastSortedColumn = el;

//                     if (binding.expression) {
//                 sortBy = binding.expression.slice(1, -1);
//             } else {
//                 sortBy = toCamelCase(el.innerText);
//             }
//             store.dispatch('sortBy', sortBy);
//         });
//     }
// });

import Vue from 'vue';
import store from '../store/store';
import { toCamelCase } from '../common/utils/strings';

export default Vue.directive('sortBy', {
    bind(el, binding) {
        el.classList.add('sorted-th');
        el.dataset.sortOrder = 'asc'; // Default sort order

        // Ensure <span> exists inside <th>, or create one
        let span = el.querySelector('span');
        if (!span) {
            span = document.createElement('span');
            span.innerHTML = el.innerHTML;
            el.innerHTML = ''; // Clear <th> content
            el.appendChild(span);
        }

        span.addEventListener('click', () => {
            let sortBy;

            // Reset previous column sorting if clicking a different column
            if (window.lastSortedColumn && window.lastSortedColumn !== span) {
                window.lastSortedColumn.classList.remove('asc', 'desc');
                window.lastSortedColumn.dataset.sortOrder = 'asc'; // Reset to default
            }

            // Toggle sort order for current column
            span.dataset.sortOrder = span.dataset.sortOrder === 'asc' ? 'desc' : 'asc';

            // Remove old sorting classes and apply new one
            span.classList.remove('asc', 'desc');
            span.classList.add(span.dataset.sortOrder);

            // Update last sorted column reference
            window.lastSortedColumn = span;

            if (binding.expression) {
                sortBy = binding.expression.slice(1, -1);
            } else {
                sortBy = toCamelCase(el.innerText);
            }
            store.dispatch('sortBy', sortBy);
        });
    }
});



// WEBPACK FOOTER //
// ./src/directives/SortByDirective.js